import React from 'react'
import PropTypes from 'prop-types'

import { Marker as MapBoxMarker } from 'react-map-gl'
import { _ClusterContent } from './styles'

const BASE_SIZE = 30

const Cluster = ({ lat, lng, className, key, onClick, count }) => {
  const countStr = String(count)
  const countStrLength = countStr.length
  let size = BASE_SIZE
  if(countStrLength > 1) size += 5
  if(countStrLength > 2) size += 5
  const clusterSize = `${Math.round(size)}px`

  return (
    <MapBoxMarker
      latitude={lat}
      longitude={lng}
      key={'cluster' + key}
    >
      <_ClusterContent
        style={{
          width: clusterSize,
          height: clusterSize,
        }}
        className={className}
        onClick={onClick}
      >
        <div>{count}</div>
      </_ClusterContent>
    </MapBoxMarker>
  )
}

Cluster.propTypes = {
  lat: PropTypes.number.isRequired,
  lng: PropTypes.number.isRequired,
  className: PropTypes.string,
  key: PropTypes.string,
  onClick: PropTypes.func,
  count: PropTypes.number,
}


export default Cluster
